import React from "react";
import ReactDOM from "react-dom";
import Warning from "./Warning";
import Loader from "./Loader";
import TableView from "./TableView";
import axios from "axios";
import _sortBy from "lodash/sortBy";
import _reverse from "lodash/reverse";

const api = axios.create({
  baseURL: `${pol.root_url}/wp-json/pol/v1/declaratii_de_avere`
});

let categName;

export default class DeclaratiiAvere extends React.Component {
  constructor(props) {
    super(props);
    this.signal = axios.CancelToken.source();
    this.state = {
      isLoading: false,
      data: []
    };
  }

  componentDidMount() {
    this.loadDeclaratii();
  }

  componentWillUnmount() {
    this.signal.cancel("Api is being canceled");
  }

  loadDeclaratii = async () => {
    try {
      this.setState({ isLoading: true });
      const request = await api.get("?categ=" + categName, {
        cancelToken: this.signal.token
      });
      const data = _reverse(_sortBy(request.data, "an"));
      this.setState({ data: data, isLoading: false });
    } catch (err) {
      if (err.response) {
        this.setState({ error: err.response.data.message });
      } else if (axios.isCancel(err)) {
        console.log(err.message);
        this.setState({ error: err.message });
      } else {
        this.setState({ isLoading: false });
      }
    }
  };

  render() {
    const error = this.state.error;
    if (error) {
      return <Warning type={"error"} message={error} />;
    } else {
      return (
        <>
          {this.state.isLoading ? (
            <Loader />
          ) : (
            <>
              {this.state.data.map((dec, i) =>
                dec.hasOwnProperty("fail") ? (
                  <Warning key={i} type={"warning"} message={dec.fail.bad} />
                ) : (
                  <div
                    className="col-lg-6 col-md-12 col-sm-12 col-12 mb-4"
                    key={i}
                    data-aos="fade"
                    data-aos-duration="1000"
                    data-aos-once="true"
                  >
                    <div className="card b-shadow border-0 mb-2 h-100 top-b">
                      <div className="card-body">
                        <h5 className="card-title mb-4">{dec.an}</h5>
                        <TableView entry={dec.set} />
                      </div>
                    </div>
                  </div>
                )
              )}
            </>
          )}
        </>
      );
    }
  }
}

if (document.getElementById("conducerea")) {
  categName = "Conducere";
  ReactDOM.render(<DeclaratiiAvere />, document.getElementById("conducerea"));
}

if (document.getElementById("personal")) {
  categName = "Personal";
  ReactDOM.render(<DeclaratiiAvere />, document.getElementById("personal"));
}
